import { object, number, boolean, string } from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const createRapidTestStandardsSchema = () => {
    const decimalPlacesSchema = number()
        .nullable()
        .transform((value) => (Number.isNaN(value) ? undefined : value))
        .integer('Precision must be a whole number')
        .min(0, 'Precision must be between 0 and 6')
        .max(6, 'Precision must be between 0 and 6');

    const numericRangeSchema = object({
        min: number()
            .nullable()
            .transform((value) => (Number.isNaN(value) ? undefined : value)),
        max: number()
            .nullable()
            .transform((value) => (Number.isNaN(value) ? undefined : value))
            .when('min', (min, schema) => {
                if (min !== undefined && min !== null) {
                    return schema.min(min, 'Maximum value must be greater than or equal to minimum value');
                }
                return schema;
            }),
        note: string().optional().nullable(),
        decimal_places: decimalPlacesSchema,
    });

    // Percent fields must have min/max between 0 and 100
    const percentRangeSchema = object({
        min: number()
            .nullable()
            .transform((value) => (Number.isNaN(value) ? undefined : value))
            .min(0, 'Minimum threshold must be at least 0%')
            .max(100, 'Minimum threshold must be at most 100%'),
        max: number()
            .nullable()
            .transform((value) => (Number.isNaN(value) ? undefined : value))
            .min(0, 'Maximum threshold must be at least 0%')
            .max(100, 'Maximum threshold must be at most 100%')
            .when('min', (min, schema) => {
                if (min !== undefined && min !== null) {
                    return schema.min(min, 'Maximum value must be greater than or equal to minimum value');
                }
                return schema;
            }),
        note: string().optional().nullable(),
        decimal_places: decimalPlacesSchema,
    });

    // pH must be between 0 and 14
    const phRangeSchema = object({
        min: number()
            .nullable()
            .transform((value) => (Number.isNaN(value) ? undefined : value))
            .min(0, 'Minimum pH must be at least 0')
            .max(14, 'Minimum pH must be at most 14'),
        max: number()
            .nullable()
            .transform((value) => (Number.isNaN(value) ? undefined : value))
            .min(0, 'Maximum pH must be at least 0')
            .max(14, 'Maximum pH must be at most 14')
            .when('min', (min, schema) => {
                if (min !== undefined && min !== null) {
                    return schema.min(min, 'Maximum value must be greater than or equal to minimum value');
                }
                return schema;
            }),
        note: string().optional().nullable(),
        decimal_places: decimalPlacesSchema,
    });

    const booleanStandardSchema = object({
        required_value: boolean().nullable(),
        note: string().optional().nullable(),
    });

    return object({
        temperature: numericRangeSchema.nullable(),
        butterfat_percent: percentRangeSchema.nullable(),
        protein_percent: percentRangeSchema.nullable(),
        solids_not_fat_percent: percentRangeSchema.nullable(),
        total_solids_percent: percentRangeSchema.nullable(),
        titratable_acidity: numericRangeSchema.nullable(),
        cryo: numericRangeSchema.nullable(),
        ph: phRangeSchema.nullable(),
        adv: numericRangeSchema.nullable(),
        antibiotics: booleanStandardSchema.nullable(),
        solids_weight: numericRangeSchema.nullable(),
        dry_matter_basis_percent: percentRangeSchema.nullable(),
        other_solids_percent: percentRangeSchema.nullable(),
        butterfat_diluted_percent: percentRangeSchema.nullable(),
        butterfat_undiluted_percent: percentRangeSchema.nullable(),
        protein_diluted_percent: percentRangeSchema.nullable(),
        protein_undiluted_percent: percentRangeSchema.nullable(),
        lactose_percent: percentRangeSchema.nullable(),
        standard_plate_count: numericRangeSchema.nullable(),
        enterobacteriaceae: numericRangeSchema.nullable(),
        sediment: numericRangeSchema.nullable(),
        flavor_aroma: booleanStandardSchema.nullable(),
    });
};
